import React, { useState } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import MiniCenteredFooter from "components/MiniCenteredFooter";
import { Image } from "react";

import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import { SectionDescription } from "components/misc/Typography.js";
import { Container as ContainerBase, ContentWithPaddingXl as ContentBase } from "components/misc/Layouts.js";
import ThreePacks from "components/ThreePacks.js";
import { Link, animateScroll as scroll } from "react-scroll";

const Container = tw(ContainerBase)`bg-primary-900 text-gray-100 px-2 relative -mx-8 -mt-20 bg-center bg-cover`;
const ContentWithPaddingXl = tw(
  ContentBase
)`relative z-10 mx-auto px-0 py-12 sm:py-20 sm:px-6 md:px-8 lg:px-12 xl:px-24 flex flex-col max-w-screen-xl`;
const HeaderContainer = tw.div`w-full flex flex-col items-center`;
const Subheading = tw(SubheadingBase)`mb-4 text-gray-100`;
const Heading = tw(SectionHeading)`w-full`;
const Description = tw(SectionDescription)`w-full text-gray-300 text-center`;
const WhiteBackgroundOverlay = tw.div`absolute inset-x-0 bottom-0 h-1/6 lg:h-1/3 bg-white z-0`;
const SlantedBackground = styled.span`
  ${tw`relative text-primary-600 px-4 -mx-4 py-2`}
  &::before {
    content: "";
    ${tw`absolute inset-0 bg-gray-100 transform -skew-x-12 -z-10`}
  }
`;

const PlanDurationSwitcher = tw.div`block w-full flex justify-between max-w-2xl sm:inline-block sm:w-auto border-2 rounded-full px-1 mx-0 py-1 mt-8`;
const SwitchButton = styled.button`
  ${tw`w-auto sm:w-32 px-4 sm:px-6 py-3 rounded-full focus:outline-none text-base font-bold text-gray-600 transition duration-300`}
  ${props => props.active && tw`bg-primary-500 text-gray-100`}
`;

export default () => {

  const [activeIndex, setActiveIndex] = useState(0);

  return (<>
    <AnimationRevealPage>
      <Container>
        <ContentWithPaddingXl>
          <HeaderContainer>
            <Subheading>Donazioni</Subheading>
            <Heading><SlantedBackground>Dona a Rewind</SlantedBackground></Heading>
            <Description>Le tue donazioni sono estremamente utili a mantenere in vita il progetto, per questo ti ringraziamo con dei bonus in gioco.<br />
              Inoltre, ogni 10€ di donazioni raggiunte sbloccherai un nuovo livello donatore in base a questo schema:<br />• 1-10€: Donatore Basic<br />• 11-20€: Donatore Silver<br />• 21-50€: Donatore Gold<br />• 51€+: Donatore Platinum</Description>
            <PlanDurationSwitcher>
              {['Pacchetti WIPE', 'Veicoli Premium', 'Donazioni singole'].map((type, index) => (
                <SwitchButton active={activeIndex === index} key={index} onClick={() => setActiveIndex(index)}>{type}</SwitchButton>
              ))}
            </PlanDurationSwitcher>
          </HeaderContainer>
          <div id="sectionpacks" />
          {activeIndex === 0 ? <>
            <ThreePacks plans={[{ name: 'Wipe+', price: '5,90€', duration: 'Acquisto PACK', features: ["$100.000 accreditati in banca"] },
            { name: 'Wipe++', price: '9,90€', duration: 'Acquisto PACK', features: ["$100.000 accreditati in banca", "Mantenimento di due veicoli tra quelli già in possesso"] },
            { name: 'Wipe+++', price: '14,90€', duration: 'Acquisto PACK', features: ["$150.000 accreditati in banca", "Mantenimento di due veicoli tra quelli già in possesso", "Una casa a scelta (non Premium)"] }]} />
          </> : activeIndex === 1 ? <>
            <ThreePacks addRow={0} plans={[{ name: 'Aston Martin DBS', price: '5,90€', duration: 'Donazione singola', featured: true },
            { name: 'Audi RS5', price: '3,90€', duration: 'Donazione singola', featured: true },
            { name: 'Bentley Flying Spur', price: '3,90€', duration: 'Donazione singola', featured: true }]} />
            <ThreePacks addRow={3} row2={true} plans={[{ name: 'BMW M3', price: '4,90€', duration: 'Donazione singola', featured: true },
            { name: 'Cadillac DTS', price: '2,90€', duration: 'Donazione singola', featured: true },
            { name: 'Chevrolet Camaro Z28 1986', price: '9,90€', duration: 'Donazione singola', featured: true }]} />
            <ThreePacks addRow={6} plans={[{ name: 'Ferrari F430', price: '13,90€', duration: 'Donazione singola', featured: true },
            { name: 'Lamborghini Gallardo', price: '7,90€', duration: 'Donazione singola', featured: true },
            { name: 'Maserati GranTurismo', price: '5,90€', duration: 'Donazione singola', featured: true }]} />
            <ThreePacks addRow={9} row2={true} plans={[{ name: 'Mercedes GT63S AMG', price: '6,90€', duration: 'Donazione singola', featured: true },
            { name: 'Mercedes S65 AMG', price: '3,90€', duration: 'Donazione singola', featured: true },
            { name: 'Nissan 180SX', price: '2,90€', duration: 'Donazione singola', featured: true }]} />
            <ThreePacks addRow={12} plans={[{ name: 'TurismoR', price: '14,90€', duration: 'Donazione singola', featured: true },
            { name: 'Sanchez', price: '9,90€', duration: 'Donazione singola', featured: true }]} />
          </> : activeIndex === 2 && <>
            <ThreePacks noBlob={true} wipes={false} plans={[{ name: 'Skin / 3D Pack', features: ["Skin Premium: 1,50€", "Skin modellata su misura: 7,90€", "Exterior modellato su misura: 9,90€", "Interior modellato su misura: 9,90€"], featured: true },
            { name: 'Money Pack', features: ["$100.000: 9,90€", "$200.000: 12,90€", "$300.000: 14,90€"], featured: true },
            { name: 'Varie', features: ["Cambio nome PG: 1,50€", "Cambio nome account: 1,50€", "Targa veicolo personalizzata: 0,90€"], featured: true }]} />
            <ThreePacks showImg={true} noBlob={true} plans={[{ name: 'Casa sulla Route 31', price: "3,90€ - 14,90€", featured: true },
            { name: 'Casa sulla Route 32', price: "4,90€ - 19,90€", featured: true }]} />
          </>}

          <HeaderContainer tw="mt-8">
            <PlanDurationSwitcher>
              {['Pacchetti WIPE', 'Veicoli Premium', 'Donazioni singole'].map((type, index) => (
                <Link
                  activeClass="active"
                  to="sectionpacks"
                  spy={true}
                  smooth={true}
                  offset={-200}
                  duration={400}>
                  <SwitchButton active={activeIndex === index} key={index} onClick={() => setActiveIndex(index)}>{type}</SwitchButton>
                </Link>
              ))}
            </PlanDurationSwitcher>
          </HeaderContainer>
        </ContentWithPaddingXl>
        <WhiteBackgroundOverlay />
      </Container>
      <MiniCenteredFooter />
    </AnimationRevealPage>
  </>);
};